import { CommonModule, CurrencyPipe, PercentPipe } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppSessionService } from './common/session/app-session.service';
import { AuthRouteGuard } from '../app/shared/common/auth/auth-route-guard';
import { PushNotificationsService } from './services/push-notifications.service';
import { ExcelService } from './services/excel.service';
import { FeatureFlagGuard } from './guards/feature-flag-guard';
import { GoogleAnalyticsService } from '../app/shared/common/analytics/google-analytics.service';
import { CustomersService } from '@shared/services/customers.service';
import { UsersService } from '@shared/services/users.service';
import { ImportService } from '@shared/services/import.service';
import { TicketsService } from '@shared/services/tickets.service';
import { JobsService } from '@shared/services/jobs.service';
import { OrdersService } from '@shared/services/orders.service';
import { ProviderProductsService } from '@shared/services/provider-products.service';
import { CommissionReviewV2Service } from '@shared/services/commission-review-v2.service';

@NgModule({
    imports: [CommonModule, RouterModule],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                AuthRouteGuard,
                FeatureFlagGuard,
                CurrencyPipe,
                PercentPipe,
                ExcelService,
                PushNotificationsService,
                GoogleAnalyticsService,
                CustomersService,
                TicketsService,
                OrdersService,
                UsersService,
                ImportService,
                JobsService,
                ProviderProductsService,
                CommissionReviewV2Service,
            ],
        };
    }
}
